// ============================================================
// MOCK DATA — Portal de Recogida San Fernando de Henares / Valoriza
// Todo lo de este archivo es temporal (frontend-only) y será
// sustituido por llamadas reales al backend en la fase 2.
// ============================================================

export const MUNICIPIO = "San Fernando de Henares";
export const MUNICIPIO_CP = "28830";
export const TICKET_PREFIX = "SFH";

export const MAP_CENTER = [40.427, -3.5337];
export const MAP_ZOOM = 14;

export const COLORS = {
  municipal: "#BD3742",
  dorado: "#43695B",
  valorizaGreen: "#009940",
  valorizaCyan: "#69C7EA",
  aytoGreen: "#5c927a",
};

// ------------------------------------------------------------
// Servicios: días válidos por tipo de servicio
// ------------------------------------------------------------
export const DIAS_SERVICIO = {
  enseres: [1, 3, 5], // Lunes, Miércoles, Viernes (0=Domingo en JS)
  poda: [2, 4], // Martes, Jueves
};

export const SERVICIOS_INFO = {
  enseres: {
    id: "enseres",
    nombre: "Muebles y Enseres",
    descripcion:
      "Recogemos hasta 3 enseres o 1 mueble de grandes dimensiones junto a tu isla de contenedores. Los aparatos eléctricos y electrónicos se llevan al Punto Limpio Móvil.",
    dias: "Lunes, Miércoles y Viernes",
    icon: "Sofa",
    color: COLORS.municipal,
    image:
      "https://images.unsplash.com/photo-1779643302127-0d0bbfa19524?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  poda: {
    id: "poda",
    nombre: "Restos de Poda",
    descripcion:
      "Recogemos restos de poda de árboles y arbustos, césped y hojas en bolsas o atillos, junto a tu isla de contenedores.",
    dias: "Martes y Jueves",
    icon: "Leaf",
    color: COLORS.valorizaGreen,
    image:
      "https://images.unsplash.com/photo-1667755582571-d7b98b88d326?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
};

export const PUNTO_LIMPIO_INFO = {
  id: "puntolimpio",
  nombre: "Punto Limpio Móvil",
  descripcion:
    "Puedes depositar pequeños enseres, aparatos eléctricos y electrónicos, aceites usados, pilas, bombillas y otros residuos peligrosos de uso doméstico, los sábados de 08:00 a 13:00.",
  dias: "Todos los sábados, 08:00 - 13:00",
  icon: "Recycle",
  color: COLORS.aytoGreen,
  image:
    "https://images.unsplash.com/photo-1532996122724-e3c354a0b15b?crop=entropy&cs=srgb&fm=jpg&q=85",
};

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1574974671999-24b7dfbb0d53?crop=entropy&cs=srgb&fm=jpg&q=85";

export const MISSION_IMAGE =
  "https://images.unsplash.com/photo-1763060893376-c95428e0a569?crop=entropy&cs=srgb&fm=jpg&q=85";

// ------------------------------------------------------------
// Listado de enseres pequeños seleccionables (máx. 3 por servicio). Los sofás y
// colchones se consideran enseres de gran tamaño (ver ENSERES_GRANDES) y se
// limitan a 1 por servicio. Los aparatos eléctricos/electrónicos NO se
// recogen a domicilio: se llevan al Punto Limpio Móvil.
// ------------------------------------------------------------
export const ENSERES_ITEMS = [
  "Armario pequeño",
  "Mesa",
  "Silla",
  "Somier",
  "Otros",
];

export const MAX_ENSERES_ITEMS = 3;

// Restos de poda: máximo 3 bolsas o atillos por servicio.
export const MAX_BULTOS_PODA = 3;

// Enseres de gran tamaño: máximo 1 por servicio.
export const ENSERES_GRANDES = [
  "Sofá 2 plazas",
  "Sofá 3 plazas",
  "Colchón",
  "Otro mueble de grandes dimensiones",
];

export const PODA_TIPOS = [
  { value: "arbustos", label: "Restos de poda de arbustos" },
  { value: "arboles", label: "Restos de poda de árboles" },
  { value: "cesped", label: "Césped" },
  { value: "hojas", label: "Hojas" },
  { value: "otros", label: "Otros restos vegetales" },
];

// Unidad de medida a mostrar al ciudadano según el tipo de resto vegetal
export const PODA_UNIDAD = {
  arbustos: "atillos o bolsas",
  arboles: "atillos o bolsas",
  cesped: "bolsas",
  hojas: "bolsas",
  otros: "bolsas o atillos",
};

// ------------------------------------------------------------
// Estadísticas landing (mock, estilo valorizasm.com)
// ------------------------------------------------------------
export const STATS = [
  { value: "3", label: "servicios disponibles: enseres, poda y Punto Limpio Móvil" },
  { value: "5", label: "días/semana en enseres y poda" },
  { value: "Sábados", label: "todas las semanas en el Punto Limpio Móvil" },
  { value: "24-48h", label: "tiempo medio de respuesta" },
  { value: "100%", label: "GRATUITO para empadronados/as" },
];

// ------------------------------------------------------------
// Noticias (mock — una basada en noticia real de Valoriza)
// ------------------------------------------------------------
export const NEWS = [
  {
    id: 1,
    title:
      "Valoriza renueva el servicio de limpieza viaria y recogida de residuos de San Fernando de Henares para los próximos diez años",
    category: "Noticias",
    image:
      "https://images.unsplash.com/photo-1574974671999-24b7dfbb0d53?crop=entropy&cs=srgb&fm=jpg&q=80",
  },
  {
    id: 2,
    title:
      "Nuevo portal online para solicitar la recogida de enseres y poda a domicilio en San Fernando de Henares",
    category: "Servicios",
    image:
      "https://images.unsplash.com/photo-1779643302127-0d0bbfa19524?crop=entropy&cs=srgb&fm=jpg&q=80",
  },
  {
    id: 3,
    title:
      "El Ayuntamiento y Valoriza refuerzan la campaña de recogida de restos de poda en primavera",
    category: "Medio ambiente",
    image:
      "https://images.unsplash.com/photo-1667755582571-d7b98b88d326?crop=entropy&cs=srgb&fm=jpg&q=80",
  },
];

// ------------------------------------------------------------
// Fin de contenido estático
// ------------------------------------------------------------
// ------------------------------------------------------------
// Helpers de UI (independientes del backend)
// ------------------------------------------------------------
export const ESTADOS = ["Notificada", "Asignada", "En Ruta", "Recogida", "Completada", "Cancelada"];

export const ESTADO_COLORS = {
  Notificada: "bg-blue-100 text-blue-700",
  Asignada: "bg-amber-100 text-amber-700",
  "En Ruta": "bg-purple-100 text-purple-700",
  Recogida: "bg-cyan-100 text-cyan-700",
  Completada: "bg-green-100 text-green-700",
  Cancelada: "bg-red-100 text-red-700",
};

